var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClubOverview(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 5.33301H10.6667C10.3934 5.33301 10.1667 5.10634 10.1667 4.83301C10.1667 4.55967 10.3934 4.33301 10.6667 4.33301H14.6667C14.9401 4.33301 15.1667 4.55967 15.1667 4.83301C15.1667 5.10634 14.9401 5.33301 14.6667 5.33301Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.99992 5.33301H1.33325C1.05992 5.33301 0.833252 5.10634 0.833252 4.83301C0.833252 4.55967 1.05992 4.33301 1.33325 4.33301H3.99992C4.27325 4.33301 4.49992 4.55967 4.49992 4.83301C4.49992 5.10634 4.27325 5.33301 3.99992 5.33301Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66659 7.66667C5.10659 7.66667 3.83325 6.39333 3.83325 4.83333C3.83325 3.27333 5.10659 2 6.66659 2C8.22659 2 9.49992 3.27333 9.49992 4.83333C9.49992 6.39333 8.22659 7.66667 6.66659 7.66667ZM6.66659 3C5.65325 3 4.83325 3.82 4.83325 4.83333C4.83325 5.84667 5.65325 6.66667 6.66659 6.66667C7.67992 6.66667 8.49992 5.84667 8.49992 4.83333C8.49992 3.82 7.67992 3 6.66659 3Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 12.667H12C11.7267 12.667 11.5 12.4403 11.5 12.167C11.5 11.8937 11.7267 11.667 12 11.667H14.6667C14.94 11.667 15.1667 11.8937 15.1667 12.167C15.1667 12.4403 14.94 12.667 14.6667 12.667Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33325 12.667H1.33325C1.05992 12.667 0.833252 12.4403 0.833252 12.167C0.833252 11.8937 1.05992 11.667 1.33325 11.667H5.33325C5.60659 11.667 5.83325 11.8937 5.83325 12.167C5.83325 12.4403 5.60659 12.667 5.33325 12.667Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33333 14.9997C7.77333 14.9997 6.5 13.7263 6.5 12.1663C6.5 10.6063 7.77333 9.33301 9.33333 9.33301C10.8933 9.33301 12.1667 10.6063 12.1667 12.1663C12.1667 13.7263 10.8933 14.9997 9.33333 14.9997ZM9.33333 10.333C8.32 10.333 7.5 11.153 7.5 12.1663C7.5 13.1797 8.32 13.9997 9.33333 13.9997C10.3467 13.9997 11.1667 13.1797 11.1667 12.1663C11.1667 11.153 10.3467 10.333 9.33333 10.333Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClubOverview);
export default __webpack_public_path__ + "static/media/clubOverview.cadad2a7.svg";
export { ForwardRef as ReactComponent };